import merge from 'lodash/merge';

import Category from '@/models/Category';
import Cover from '@/models/Cover';
import PostType from '@/models/PostType';
import SpeciesType from '@/models/SpeciesType';

class BlogPost {
  constructor(data) {
    this.title = '';
    this.slug = '';
    this.published_at = '';
    this.intro = '';
    this.cover = new Cover();
    this.categories = [];
    this.post_type = new PostType();
    this.species_types = [];
    this.read_time = 0;

    if (data) {
      merge(this, data);
    }

    if (data.categories?.length) {
      this.categories = data.categories.map((category) => new Category(category));
    }

    if (data.cover) {
      this.cover = new Cover(data.cover);
    }

    if (data.post_type) {
      this.post_type = new PostType(data.post_type);
    }

    if (data.species_types?.length) {
      this.species_types = data.species_types.map((type) => new SpeciesType(type));
    }
  }

  isBudgeting() {
    return this.post_type?.slug === 'budgeting';
  }

  isInGlossary() {
    return this.post_type?.slug === 'glossary';
  }
}

export default BlogPost;
